// Actions
export const API_RESPONSE_SUCCESS = 'API_RESPONSE_SUCCESS';
export const API_RESPONSE_ERROR = 'API_RESPONSE_ERROR';
export const GET_PROVIDER_SPECIALTY = 'GET_PROVIDER_SPECIALTY';
export const CREATE_PROVIDER_SPECIALTY = 'CREATE_PROVIDER_SPECIALTY';
export const UPDATE_PROVIDER_SPECIALTY = 'UPDATE_PROVIDER_SPECIALTY';
export const DELETE_PROVIDER_SPECIALTY = 'DELETE_PROVIDER_SPECIALTY';
export const GET_PROVIDER_SPECIALTY_BY_ID = 'GET_PROVIDER_SPECIALTY_BY_ID';
